import { timeStampToString} from "./TimeManager";

export function capitalize(str:string) {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export function validatePassword(str:string): boolean {
    // at least six characters
    const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
    const res= re.test(str);
    return str.length >= 6 && res;
}

export function validateEmail(email:string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email));
}

export function getVersion():string {
    return "เวอร์ชัน " + (process.env.REACT_APP_TAG || 'unknown').toUpperCase()
}

export function booleanCleaner(value:any) {
    if (value === "true" || value === true || value === 1) {
        return true;
    } else if (value === "false" || value === false || value === 0) {
        return false;
    } else {
        return null;
    }
}

export function booleanComparator(value1:any, value2:any) {
    const value1Cleaned = booleanCleaner(value1);
    const value2Cleaned = booleanCleaner(value2);
    const value1Ordinal = value1Cleaned === true ? 0 : (value1Cleaned === false ? 1 : 2);
    const value2Ordinal = value2Cleaned === true ? 0 : (value2Cleaned === false ? 1 : 2);
    return value1Ordinal - value2Ordinal;
}

export function dateMilliToDateFormatter(params: any){
    return timeStampToString(params.value.toString(), 'DD-MMM-YYYY HH:mm:ss.SSS Z')
}
